"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicResourceObserver = void 0;
// 10s 检测一次
var DETECT_INTERVAL = 10000;
var DynamicResourceObserver = /** @class */ (function () {
    function DynamicResourceObserver(appName, handler) {
        this.timer = null;
        this.lastCheck = 0;
        DynamicResourceObserver.listenerMap[appName] = handler;
    }
    DynamicResourceObserver.dispatchEvent = function (entries) {
        try {
            for (var _i = 0, _a = Object.values(DynamicResourceObserver.listenerMap); _i < _a.length; _i++) {
                var handler = _a[_i];
                handler(entries);
            }
        }
        catch (error) {
            //
        }
    };
    DynamicResourceObserver.prototype.observe = function () {
        this.lastCheck = +new Date();
        // start
        if (DynamicResourceObserver.active) {
            return;
        }
        this.detect();
        DynamicResourceObserver.active = true;
    };
    DynamicResourceObserver.prototype.getNewEntries = function () {
        var _this = this;
        try {
            var timeOrigin_1 = performance.timeOrigin || performance.timing.navigationStart;
            var newEntries = performance.getEntriesByType('resource')
                .filter(function (entry) { return entry.startTime + Math.max(entry.duration, 0) + timeOrigin_1 >= _this.lastCheck; });
            if (newEntries.length) {
                DynamicResourceObserver.dispatchEvent(newEntries);
                /**
                 *  正在加载中的资源可能还获取不到， 但时间可能早于当前时间戳
                 * 因此仅在获取到新资源时更新last check
                 * TODO： 需要更精确的判断
                 */
                this.lastCheck = +new Date();
            }
        }
        catch (error) {
            //
        }
    };
    DynamicResourceObserver.prototype.detect = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.getNewEntries();
        }, DynamicResourceObserver.interval);
        /** https://developers.google.com/web/updates/2018/07/page-lifecycle-api#the-unload-event */
        var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'beforeunload';
        window.addEventListener(terminationEvent, function () {
            _this.getNewEntries();
        });
    };
    DynamicResourceObserver.listenerMap = {};
    DynamicResourceObserver.active = false;
    DynamicResourceObserver.interval = DETECT_INTERVAL;
    return DynamicResourceObserver;
}());
exports.DynamicResourceObserver = DynamicResourceObserver;
